<template>
    <footer class="footer" :class="{'footer-pink': !!message}">
        <div class="container relative mx-auto">
            <span v-html="message"></span>
            <span class="footer__close">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 10.8995L10.8995 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  <path d="M10.8995 10.8995L1 1.00004" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </span>
            <div id="chat_v1hqaxhd"></div>
        </div>
    </footer>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'bottom',

        computed: mapState('footer', ['message']),

        data() {
            return {
                chatLoaded: false,
                watchingIframe: false,
            };
        },

        mounted() {
            // this.listen('chat.loaded', this.initChat);

            const footer = document.querySelector('.footer');
            const footerClose = footer.querySelector('.footer__close');

            if (footerClose) {
                footerClose.addEventListener('click', (e) => {
                    e.preventDefault();
                    footer.classList.add('hide');
                });
            }

            // this.initChat();
        },

        beforeDestroy() {
            if (this.watchingIframe) {
                window.removeEventListener('resize', this.setIframeSize);
            }
        },

        destroyed() {
            // this.silence('chat.loaded', this.initChat);
        },

        methods: {
            // initChat() {
            //     if (!window.Chat || this.chatLoaded) {
            //         return;
            //     }
            //
            //     this.chatLoaded = true;
            //
            //     window.Chat.init({
            //         'container': 'chat_v1hqaxhd',
            //         'key': process.env.VUE_APP_LIVE_CHAT_KEY,
            //         'src': 'ascenti.ourcontactcentre.com/webchat'
            //     });
            //
            //     this.setIframeSize();
            //
            //     window.addEventListener('resize', this.setIframeSize);
            //
            //     this.watchingIframe = true;
            // },

            setIframeSize() {
                const iframe = document.querySelector('#chat_v1hqaxhd iframe');

                const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                if (windowWidth < 768) {
                    iframe.style.left = '50%';
                    iframe.style.right = 'auto';
                    iframe.style.transform = 'translateX(-50%)';
                    iframe.style.width = windowWidth >= 375 ? '360px' : '320px';
                } else {
                    iframe.style.left = 'auto';
                    iframe.style.right = '10%';
                    iframe.style.width = '390px';
                    iframe.style.transform = 'none';
                }
            },
        }
    }
</script>
